import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/basic-info/measurement-unit`;

export const measurementUnitRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:measurementUnitId`,
} as const;

export type IMeasurementUnitRouteParams = IExtractRouteParamMap<
  typeof measurementUnitRoutesObj
>;

export const measurementUnitPath = createPaths<
  typeof measurementUnitRoutesObj,
  IMeasurementUnitRouteParams
>(measurementUnitRoutesObj);
